import { StyledStatusCircleIcon } from 'v3/shared/components/CircleIcon/styles';

export default function PaymentStatusIcon() {
  return <StyledStatusCircleIcon />;
}
